import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Selltable = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  return (
    <div>
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">پوختەی فرۆشراو</h2>
            </div>
          <table className="w-full">
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی بڕی کاڵای فرۆشراو</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(money_rounding(initState.total_sell_qty))}</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی فرۆش</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(iqd_rounding(initState.total_sell_price))} IQD</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی بڕی خزمەتگوزاری ئەنجامدراو</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(money_rounding(initState.total_service_qty))}</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی خزمەتگوزاری</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(iqd_rounding(initState.total_service_price))} IQD</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی بڕی کاڵای گەڕاوە</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(money_rounding(initState.total_return_qty))}</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">کۆی گەڕاوە</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(iqd_rounding(initState.total_return_price))} IQD</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">پوختەی بڕی کاڵای ڕۆشتوو</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(Number(initState.total_sell_qty)-Number(initState.total_return_qty))}</td>
                </tr>
                <tr>
                    <th className="px-6 py-3 text-right text-xs font-semibold bg-slate-50 text-slate-500 uppercase tracking-wide">پوختەی فرۆش</th>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">{numberbeautify(iqd_rounding(((Number(initState.total_sell_price)-Number(initState.total_return_price))+Number(initState.total_service_price))))} IQD</td>
                </tr>
        </table>
    </div>
</div>
  )
}

export default Selltable